import { render, staticRenderFns } from "./CanteenWidget.vue?vue&type=template&id=2dff0a1e&scoped=true&"
import script from "./CanteenWidget.vue?vue&type=script&lang=js&"
export * from "./CanteenWidget.vue?vue&type=script&lang=js&"
import style0 from "./CanteenWidget.vue?vue&type=style&index=0&id=2dff0a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff0a1e",
  null
  
)

export default component.exports